import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-configuration-delete-confirmation-dialog',
    templateUrl: './parameter-single-delete-confirmation-dialog.component.html',
    styleUrls: ['./parameter-single-delete-confirmation-dialog.component.scss'],
    standalone: false
})
export class ParameterSingleDeleteConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
  }


  deleteParameter() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
